/** One reference for the whole DS, so a dimmed `style` prop never churns. */
const DIMMED = { opacity: 0.5 } as const;

/**
 * The DS disabled dim, as a STYLE rather than an `opacity-50` class: flipping
 * a runtime-processed NativeWind class in place crashes on native
 * (`flashka-native/no-runtime-class-toggle`), and web's `input-otp` container
 * has no class hook either. Returns the same object every time, so passing it
 * to `style` is identity-stable across renders.
 */
export function disabledDimStyle(disabled?: boolean): { opacity: number } | undefined {
  return disabled ? DIMMED : undefined;
}
